import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientproductApiController from "services/clientproducts.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const ClientproductApi = createAsyncThunk("clientproduct/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientproductApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isListView: [],
  isClientDetailToSale: "",
  isApiStatus: {
    ClientproductApi: "",
  },
};

const clientproductSlice = createSlice({
  name: "clientproduct",
  initialState,
  reducers: {
    reset: () => initialState,
    clienttosaleproduct: (state, action) => {
      state.isClientDetailToSale = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientproductApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "loading" };
      })
      .addCase(ClientproductApi.fulfilled, (state, action) => {
        let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
        let new_current_page = action.payload.current_page ? action.payload.current_page : "";
        let viewdata = state.isListView && state.isListView.data;
        let newviewdata = action.payload && action.payload.data;
        state.isListView = action.payload;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : action.payload;
        }
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "succeeded" };
        state.isListView = action.payload;
      })
      .addCase(ClientproductApi.rejected, (state) => {
        state.isListView = [];
        state.isApiStatus = { ...state.isApiStatus, ClientproductApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, clienttosaleproduct } = clientproductSlice.actions;
export default clientproductSlice.reducer;
